module.exports = global["Tether"] = require("-!E:\\xampp\\htdocs\\OWL\\avo\\site\\themes\\avo\\_dev\\node_modules\\tether\\dist\\js\\tether.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
 ** module id = 2
 ** module chunks = 0
 **/